import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var DistributeSpacingHorizontal = function DistributeSpacingHorizontal(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21 21V3M3 21V3m6 5v8c0 .9319 0 1.3978.1522 1.7654.203.49.5924.8794 1.0824 1.0824C10.6022 19 11.0681 19 12 19s1.3978 0 1.7654-.1522c.49-.203.8794-.5924 1.0824-1.0824C15 17.3978 15 16.9319 15 16V8c0-.9319 0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C13.3978 5 12.9319 5 12 5s-1.3978 0-1.7654.1522a2 2 0 0 0-1.0824 1.0824C9 6.6022 9 7.0681 9 8"
    })
  }));
};
export default DistributeSpacingHorizontal;